import s from './ChangePasswordForm.scss'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Container, Col, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap'
import { Spinner } from 'components/ideal-core-ui'

const ChangePasswordForm = props => {
  const { formSubmit, isError } = props
  return (
    <Formik
      props={props}
      initialValues={{ password: '', confirmPassword: '' }}
      onSubmit={(values, { setSubmitting }) => {
        formSubmit(values).then(() => setTimeout(() => setSubmitting(false), 2000))
      }}
      validationSchema={Yup.object().shape({
        password: Yup.string().required('Password field is required!'),
        confirmPassword: Yup.string()
          .oneOf([Yup.ref('password'), null], 'Passwords must match')
          .required('Confirm Password is required')
      })}
    >
      {props => {
        const { values, touched, errors, isSubmitting, handleBlur, handleChange, handleSubmit } =
          props

        return (
          <Container className={s.container}>
            <div className={s.header} />
            <Form className={s.form} onSubmit={handleSubmit}>
              <p className={s.title}>Set New Password</p>
              <Col>
                <FormGroup>
                  <Label for="password">New Password</Label>
                  <Input
                    type="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    name="password"
                    placeholder="Password"
                    disabled={isSubmitting}
                  />
                  {errors.password && touched.password && (
                    <div className={s.inputFeedback}>{errors.password}</div>
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="confirmPassword">Confirm Password</Label>
                  <Input
                    type="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.confirmPassword}
                    name="confirmPassword"
                    placeholder="Comfirm Password"
                    disabled={isSubmitting}
                  />
                  {errors.confirmPassword && touched.confirmPassword && (
                    <div className={s.inputFeedback}>{errors.confirmPassword}</div>
                  )}
                </FormGroup>
              </Col>
              <Button className={s.loginBtn} type="submit">
                {isSubmitting ? <Spinner /> : 'Submit'}
              </Button>
              <div className={s.clearfix} />
              {isError && (
                <Alert className={s.marginTop} color="danger">
                  An error has occured. Please contact support
                </Alert>
              )}
            </Form>
          </Container>
        )
      }}
    </Formik>
  )
}

export default ChangePasswordForm
